import { render, staticRenderFns } from "./unusualOrder.vue?vue&type=template&id=06af1d19&scoped=true"
import script from "./unusualOrder.vue?vue&type=script&lang=js"
export * from "./unusualOrder.vue?vue&type=script&lang=js"
import style0 from "./unusualOrder.vue?vue&type=style&index=0&id=06af1d19&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06af1d19",
  null
  
)

export default component.exports